import React from 'react'
import EditProfileTab from './Components/EditProfileTab/EditProfileTab'
import PreferencesTab from './Components/PreferencesTab/PreferencesTab'
import SecurityTab from './Components/SecurityTab/SecurityTab'
import { Link } from 'react-router-dom'

const Setting = () => {
    return (
        <div>
            {/* x---------------------------------x Setting Option Section x---------------------------------x */}
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Settings Option</h3>
                            <Link to="/" className="text-dark text-end fs-5 fw-semibold  d-block d-sm-none">see
                                all</Link>
                        </div>
                        <div className="rounded-4 mb-3 mb-sm-0 bg-white w-100 h-100">
                            <div className="card-body rounded">
                                <ul className="nav nav-tabs tab-dynamic px-0 mb-4" role="tablist"
                                    style={{ "--dynamic-color": "var(--primary-color)" }}>
                                    {/* x---------------------------------x Edit Profile Tab Link x---------------------------------x */}
                                    <li className="nav-item" role="presentation">
                                        <Link className="ps-2 pe-3 nav-link active" data-bs-toggle="tab"
                                            to="#pills-home" role="tab" aria-selected="false"
                                            tabIndex="-1">Edit Profile</Link>
                                    </li>

                                    {/* x---------------------------------x Prefrences Tab Link x---------------------------------x */}
                                    <li className="nav-item" role="presentation">
                                        <Link className="ps-2 pe-3 nav-link " data-bs-toggle="tab"
                                            to="#pills-profile" role="tab"
                                            aria-selected="true">Preferences</Link>
                                    </li>

                                    {/* x---------------------------------x Security Tab Link x---------------------------------x */}
                                    <li className="nav-item" role="presentation">
                                        <Link className="ps-2 pe-3 nav-link" data-bs-toggle="tab"
                                            to="#pills-contact" role="tab" aria-selected="false"
                                            tabIndex="-1">Security</Link>
                                    </li>
                                </ul>

                                {/* x---------------------------------x Tab Content Section x---------------------------------x */}
                                <div className="tab-content" id="pills-tabContent">
                                    {/* x---------------------------------x Edit Profile Tab x---------------------------------x */}
                                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
                                        aria-labelledby="pills-home-tab" tabIndex="0">
                                        <EditProfileTab />
                                    </div>

                                    {/* x---------------------------------x Prefrences Tab x---------------------------------x */}
                                    <div className="tab-pane fade" id="pills-profile" role="tabpanel"
                                        aria-labelledby="pills-profile-tab" tabIndex="0">
                                        <PreferencesTab />
                                    </div>

                                    {/* x---------------------------------x Security Tab x---------------------------------x */}
                                    <div className="tab-pane fade" id="pills-contact" role="tabpanel"
                                        aria-labelledby="pills-contact-tab" tabIndex="0">
                                        <SecurityTab />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Setting